import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';
import { withApolloTypename } from 'ZalamoLibrary/src/lib/core/graphql/with-apollo-typename';

import {
  BehaviorSubject,
  Subject,
  combineLatest,
  delay,
  filter,
  first,
  fromEvent,
  map,
  merge,
  of,
  pipe,
  pluck,
  startWith,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';

import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Injector,
  OnInit,
  TemplateRef,
  ViewChild,
  ɵcreateInjector as createInjector,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  BottomMenuItem,
  ElementAvailableToAdd,
  NavigationMenuItem,
} from '../../../../../zalamo-library/src/lib/ui/navigation/navigation.component';
import { select, Store } from '@ngrx/store';

import { RightBottomIconService } from '@ui/bottom-icon/right-bottom-icon.service';
import { SupportIconComponent } from '@ui/support/components/support-icon/support-icon.component';
import { CustomizationIconComponent } from '@ui/customization/components/customization-icon/customization-icon.component';
import {
  ToggleSupportChat,
  ToggleSupportChatIcon,
} from '@ui/support/actions/actions';
import { isChatOpenSelector } from '@ui/support/actions/selectors';
import { ZalamoDialogService } from 'projects/zalamo-library/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { Router } from '@angular/router';
import { UploadService } from 'ZalamoLibrary/src/lib/upload/upload.service';
import {
  MineOrganizationsGQL,
  PermissionRole,
} from 'ZalamoLibrary/src/lib/core/organizations/organization-member/graphql';
import { setCurrentOrganization } from 'ZalamoLibrary/src/lib/core/organizations/organization/redux/organization.actions';
import { environment } from '../../../environments/environment';
import { OrderSubscriptionService } from '@ui/orders/orders-services/order-subscription.service';
import { ApmService } from '@elastic/apm-rum-angular';
import { UserConfigService } from 'ZalamoLibrary/src/lib/zalamo/user/user-config.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FancyCircleOverlayService } from 'ZalamoLibrary/src/lib/ui/animation/fancy-circle-overlay.service';
import { LastSeenPublicSessionsComponent } from '../quick-previews/last-seen-public-sessions/last-seen-public-sessions.component';
import { QuickPreviewService } from 'ZalamoLibrary/src/lib/ui/smart-preview/quick-preview.service';
import {
  GetMineBlackFridayConfigGQL,
  GetMineMenuSortOrderGQL,
  GetMineMenuVisibilityGQL,
  GetMineTimeZoneGQL,
  ImagesContainer,
  IsUserTesterGQL,
  MinePersonalizationGQL,
  SavePersonalizationGQL,
  UpdateMineMenuSortOrderGQL,
  UpdateMineMenuVisibilityGQL,
  UserTest,
} from '../../../graphql';
import { Actions, ofType } from '@ngrx/effects';
import {
  SaveCustomizations,
  SetCustomization,
} from 'ZalamoLibrary/src/lib/ui/customization/actions/customization';
import { CustomizationService } from 'ZalamoLibrary/src/lib/ui/customization/customization.service';
import { LastSeenPrivateSessionsComponent } from '../quick-previews/last-seen-private-sessions/last-seen-private-sessions.component';
import { FixMissingUserAvatar } from 'ZalamoLibrary/src/lib/zalamo/user/actions';
import { AvatarQuickFixComponent } from '../../modules/account/views/photographer-account-details/avatar-setter/avatar-quick-fix/avatar-quick-fix.component';
import { ZalamoLocalClientService } from 'ZalamoLibrary/src/lib/ui/zalamo-local-client/zalamo-local-client.service';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import {
  PickFilesFromContext,
  PickFilesFromContextResult,
} from '../../rzjs/actions';
import { ImagesInContextDrawerComponent } from '@ui/image-management/images-in-context-drawer/images-in-context-drawer.component';
import { OrdersService } from '@ui/orders/services/orders.service';
import { OrderContext } from 'graphql/libs/product-orders-management/src/graphql';
import { PhotoStatusOnTheList } from '@ui/image-management/image-viewer/types';
import { queriesInProgress$ } from './inProgressCount';
import { OrganizationDetailsService } from 'ZalamoLibrary/src/lib/core/organizations/organization-details.service';
import { BookingSubscriptionsService } from '@ui/booking/booking-subscriptions/booking-subscriptions.service';
import { JWTService } from 'ZalamoLibrary/src/lib/zalamo/auth/jwt-parser-service';
import { ZalamoAuthService } from 'ZalamoLibrary/src/lib/zalamo/auth/zalamo-auth.service';

if (environment.production) {
  // LogRocket.init('b4gb2y/nowy-panel-fotografa');
}

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContainerComponent implements OnInit {
  bottomMenu: Array<BottomMenuItem> = [
    {
      label: 'Powiadomienia',
      url: ['/account/notifications'],
    },
    { label: 'Moje konto', url: ['/account'] },
  ];
  shouldOpenAdd$ = new Subject();
  queriesInProgress$ = queriesInProgress$;
  isOffline$ = merge(
    of(null),
    fromEvent(window, 'online'),
    fromEvent(window, 'offline'),
  ).pipe(map(() => !navigator.onLine));

  availableToAdd: Array<ElementAvailableToAdd<ContainerComponent>> = [
    {
      id: 'public_session',
      parent: this,
      isMain: true,
      async handler() {
        console.log('Add New Public Session');
        const { AddPublicSessionComponent } =
          await import('../../modules/public-session/views/add-public-session/add-public-session.component');
        const ref = this.parent.dialog.openFull(AddPublicSessionComponent);
        this.parent.router.events
          .pipe(takeUntil(ref.beforeClosed()))
          .subscribe(() => ref.close());
      },
      badge: '',
      icon: 's_public_session',
    },

    {
      id: 'print_product',
      parent: this,
      isMain: false,
      async handler() {
        this.parent.router.navigate(['/stocks/add'], {
          queryParams: { add: 1 },
        });
      },
      badge: '',
      icon: 's_products',
    },
    // {
    //   id: 'lookbook',
    //   parent: this,
    //   isMain: false,
    //   async handler() {
    //     const { LookBookAddViewComponent } = await import(
    //       '../../modules/look-book/look-book-add-view/look-book-add-view.component'
    //     );
    //     const ref = this.parent.dialog.openFull(LookBookAddViewComponent);
    //     this.parent.router.events
    //       .pipe(takeUntil(ref.beforeClosed()))
    //       .subscribe(() => ref.close());
    //   },
    //   badge: '',
    //   icon: 'zalamo-lookbook-logo',
    // },
    {
      id: 'private_session',
      parent: this,
      isMain: true,
      async handler() {
        console.log('Add New private Session');
        const { PrivateSessionStepContainerComponent } =
          await import('../../modules/private-sessions/components/add-new-steps/private-session-step-container/private-session-step-container.component');
        const ref = this.parent.dialog.openFull(
          PrivateSessionStepContainerComponent,
          { isBare: true },
        );
        ref.componentInstance.finished
          .pipe(
            takeUntil(ref.afterClosed()),
            tap(() => ref.close()),
          )
          .subscribe();
        this.parent.router.events
          .pipe(takeUntil(ref.beforeClosed()))
          .subscribe(() => ref.close());
      },
      badge: '',
      icon: 's_private_session',
    },
  ] as Array<ElementAvailableToAdd<ContainerComponent>>;
  title = 'PhotographerPanel';
  isChatOpen = this.store.pipe(select(isChatOpenSelector));
  isFaqOpen = new BehaviorSubject(false);
  @ViewChild('container', { static: true }) container: ElementRef<HTMLElement>;
  isSupportVisible = combineLatest([this.isChatOpen, this.isFaqOpen]).pipe(
    map(([isChatOpen, isFaqOpen]) => isChatOpen || isFaqOpen),
    tap(() => {
      console.log('UPDATE FLEXBOX');
      const elem = this.container.nativeElement;
      elem.style.position = 'fixed';
      elem.offsetHeight; // no need to store this anywhere, the reference is enough
      elem.style.position = 'static';
    }),
  );
  currentSortOrder$ = new BehaviorSubject([]);
  wasHidden = false;
  navigationConfigNotLoaded = true;
  mainMenu: Array<NavigationMenuItem> = [
    // {
    //   label: 'Strona główna',
    //   icon: 'home',
    //   // class: 'add',
    //   path: ['/'],
    //   isDefault: true,
    //   id: 'home',
    //   isVisible: true,
    //   isMatIcon: true,
    //   mobileOnly: true,
    // },
    {
      id: 'public_session',
      icon: 's_public_session',
      isDefault: false,
      isVisible: true,
      label: 'Sesje publiczne',
      path: ['/public-sessions'],
    },
    {
      id: 'tablo_designer',
      icon: 'designer',
      isDefault: false,
      isVisible: true,
      label: 'Kreator',
      path: ['/designer'],
    },
    {
      id: 'booking',
      icon: 'booking',
      path: ['booking'],
      isVisible: true,
      label: 'Booking Lite',
      isDefault: false,
    },
    {
      id: 'private_session',
      icon: 's_private_session',
      path: ['private-sessions'],
      isVisible: true,
      label: 'Sesje prywatne',
      isDefault: false,
    },
    // {
    //   id: 'school_stats',
    //   icon: 'bar_chart',
    //   isMatIcon: true,
    //   path: ['stats'],
    //   isVisible: true,
    //   label: 'Statystyki szkolne',
    //   isDefault: false,
    // },
    {
      id: 'order_list',
      icon: 's_order_list',
      isDefault: false,
      isVisible: true,
      label: 'Zamówienia',
      path: ['/orders'],
    },
    {
      id: 'crm',
      icon: 's_clients',
      isDefault: true,
      isVisible: true,
      label: 'Klienci',
      path: ['/crm'],
    },

    {
      label: 'Moje wydruki',
      icon: 's_products',
      // class: 'add',
      path: ['/stocks'],
      isDefault: false,
      id: 'products',
      isVisible: true,
    },
    {
      id: 'suppliers',
      icon: 'local_shipping',
      isDefault: false,
      isVisible: true,
      isMatIcon: true,
      label: 'Moi dostawcy',
      path: ['/suppliers'],
    },
    {
      id: 'public-session-organizations',
      icon: 'school',
      isDefault: false,
      isVisible: false,
      isMatIcon: false,
      label: 'Moje placówki',
      path: ['/public-session-organizations'],
    },
    // {
    //   id: 'look_book_list',
    //   icon: 'zalamo-lookbook-logo',
    //   isDefault: false,
    //   isVisible: false,
    //   label: 'LookBook',
    //   path: ['/lookbook'],
    // },
  ];
  mainMenu$ = new BehaviorSubject([]);
  isMobile = this.breakpointObserver
    .observe([Breakpoints.Handset])
    .pipe(map(({ matches }) => matches));
  isAdmin$ = new BehaviorSubject(false);
  mineOrganizations$ = this.mineOrganizations
    .fetch({})
    .pipe(pluck('data', 'mineOrganizations'));

  @ViewChild('blackFriday', { static: true }) blackFriday: TemplateRef<any>;

  constructor(
    bottomMenu: RightBottomIconService,
    private store: Store,
    private dialog: ZalamoDialogService,
    private router: Router,
    public serviceUpload: UploadService,
    private mineOrganizations: MineOrganizationsGQL,
    ordersService: OrderSubscriptionService,
    service: ApmService,
    private userConfigService: UserConfigService,
    private breakpointObserver: BreakpointObserver,
    private fancy: FancyCircleOverlayService,
    private quickPreviewService: QuickPreviewService,
    private injector: Injector,
    minePersonalizationGQL: MinePersonalizationGQL,
    actions$: Actions,
    savePersonalizationGQL: SavePersonalizationGQL,
    private changeDetectorRef: ChangeDetectorRef,
    getMineMenuSortOrderGQL: GetMineMenuSortOrderGQL,
    getMineMenuVisibilityGQL: GetMineMenuVisibilityGQL,
    private updateMineMenuSortOrderGQL: UpdateMineMenuSortOrderGQL,
    private updateMineMenuVisibilityGQL: UpdateMineMenuVisibilityGQL,
    private customizationService: CustomizationService,
    isUserTesterGQL: IsUserTesterGQL,
    public zalamoLocalClientService: ZalamoLocalClientService,
    private getMineTimeZoneGQL: GetMineTimeZoneGQL,
    private organizationService: OrganizationService,
    private ordersSearchService: OrdersService,
    private organizationDetailsService: OrganizationDetailsService,
    private bookingSubscriptionsService: BookingSubscriptionsService,
    private getMineBlackFridayConfigGQL: GetMineBlackFridayConfigGQL,
    private zalamoDialogService: ZalamoDialogService,
    public jwtService: JWTService,
    private zalamoAuthService: ZalamoAuthService,

    public viewContainerRef: ElementRef,
  ) {
    // isUserTesterGQL
    //   .fetch({
    //     test: UserTest.TabloDesigner,
    //   })
    //   .pipe(
    //     first(),
    //     tap((isTester) => {
    //       if (isTester.data.isUserTester) {
    //         this.mainMenu = [
    //           ...this.mainMenu,
    //
    //         ];
    //       }
    //     }),
    //   )
    //   .subscribe();
    // combineLatest([
    //   fetch('https://zalamo.com/gettimestamp.php').then((v) => v.text()),
    //   this.getMineBlackFridayConfigGQL.fetch(),
    // ])
    //   .pipe(first())
    //   .subscribe(([timestamp, v]) => {
    //     console.log('black friday', v, timestamp);
    //     if (
    //       !v.data.getMineBlackFridayConfig.used &&
    //       !v.data.getMineBlackFridayConfig.disabled
    //     ) {
    //       if (
    //         v.data.getMineBlackFridayConfig.postponed === 0 ||
    //         v.data.getMineBlackFridayConfig.postponed + 3600 * 4 <
    //           Number(timestamp)
    //       ) {
    //         const ref = this.zalamoDialogService.openFull(
    //           BlackFridayComponent,
    //           {
    //             closable: false,
    //             isBare: true,
    //           },
    //         );
    //         ref.componentInstance.closed.pipe(first()).subscribe(() => {
    //           ref.close();
    //         });
    //       }
    //     }
    //   });
    isUserTesterGQL
      .fetch({
        variables: {
          test: UserTest.P3,
        },
      })
      .pipe(
        first(),
        tap((isTester) => {
          if (isTester.data.isUserTester) {
            this.mainMenu.push({
              id: 'tracking',
              icon: 'checklist',
              isDefault: false,
              isVisible: true,
              isMatIcon: true,
              label: 'Zlecenia',
              path: ['/clth43xm0000008la99ct3man'],
            });
          }
        }),
      )
      .subscribe();
    bottomMenu.registerComponent(2, SupportIconComponent);
    bottomMenu.registerComponent(1, CustomizationIconComponent);
    this.bookingSubscriptionsService.subToScheduleEvents();
    organizationService
      .getCurrentOrganization()
      .pipe(
        switchMap((organizationId) =>
          this.getMineTimeZoneGQL.fetch({ variables: { organizationId } }),
        ),
        map(
          ({
            data: {
              me: { timeZone },
            },
          }) => timeZone,
        ),
      )
      .subscribe((org) => {
        // alert(org);
      });
    this.organizationDetailsService.flags$.pipe().subscribe((res) => {
      console.log(res);
      if (res?.hideOrders) {
        this.mainMenu = this.mainMenu.filter(
          (item) => item.id !== 'order_list',
        );
      } else {
        if (!this.mainMenu.find((item) => item.id === 'order_list')) {
          this.mainMenu.push({
            id: 'order_list',
            icon: 's_order_list',
            isDefault: false,
            isVisible: true,
            label: 'Zamówienia',
            path: ['/orders'],
          });
        }
      }
    });
    this.mineOrganizations$.subscribe((res) => {
      console.log(res, environment);
      if (environment.production) {
        // LogRocket.identify(localStorage.lastValidLogin, {
        //   name: res[0].name,
        //   email: localStorage.lastValidLogin,
        // });
        const apm = service.init({
          serviceName: 'Photographer Panel',
          serverUrl: 'https://apm.zalamo.com:8200',

          distributedTracingOrigins: [
            // 'https://obrazki2.zalamo.com',
            // 'https://obrazki.zalamo.com',
            // 'https://obrazki3.zalamo.com',
            'https://graph5.zalamo.com',
          ],
        });
        apm.setUserContext({
          username: res[0].name,
          email: localStorage.lastValidLogin,
        });
      }

      this.isAdmin$.next(res[0].roles.includes(PermissionRole.Admin));
      if (this.isAdmin$.value) {
        this.bottomMenu.push({
          label: 'Moje studio',
          url: ['/studio-manager'],
        });
      }
      this.zalamoLocalClientService.isConnected.subscribe((isConnected) => {
        this.bottomMenu = this.bottomMenu.filter(
          (item) => item.label !== 'Zalamo Sync',
        );
        if (!isConnected) {
          const OS = /Mac/i.test(navigator.platform)
            ? 'macOS'
            : /Win/i.test(navigator.platform)
              ? 'Windows'
              : 'Other';

          this.bottomMenu.push({
            label: 'Zalamo Sync',
            url: [
              OS === 'macOS'
                ? 'https://download.zalamo.com/files/ZalamoSync/4b86b03ae6620ac69445724d9e7200bc/_index/1.0.3/darwin/x64/Zalamo%20Sync-1.0.3-x64.dmg'
                : 'https://download.zalamo.com/files/ZalamoSync/4b86b03ae6620ac69445724d9e7200bc/latest/win32/x64/ZalamoSync.exe',
            ],
          });
        } else {
        }
        this.bottomMenu = [...this.bottomMenu];
      });

      store.dispatch(
        setCurrentOrganization({
          organizationId:
            (localStorage.lastZalamoOrganizationId &&
              res.find(
                (v) =>
                  v.organizationId === localStorage.lastZalamoOrganizationId,
              )?.organizationId) ??
            res[0].organizationId,
        }),
      );
    });
    console.log('SUB TO ORDERS');
    ordersService.subToOrders();
    this.quickPreviewService.registerService(
      'public_session',
      (targetName, containerRef, data) => {
        return this.quickPreviewService.showPreview(
          targetName,
          LastSeenPublicSessionsComponent,
          containerRef,
          data,
        );
      },
    );
    this.quickPreviewService.registerService(
      'private_session',
      (targetName, containerRef, data) => {
        return this.quickPreviewService.showPreview(
          targetName,
          LastSeenPrivateSessionsComponent,
          containerRef,
          data,
        );
      },
    );
    this.quickPreviewService.registerService(
      'order_list',
      async (targetName, containerRef, data) => {
        const { OrdersModule } =
          await import('../../../../../zalamo-library/src/lib/ui/orders/orders.module');
        const injector = createInjector(OrdersModule, this.injector);
        const carouselModule = injector.get(OrdersModule);
        return this.quickPreviewService.showPreview(
          targetName,
          carouselModule.getQuickPreview(),
          containerRef,
          data,
        );
      },
    );
    minePersonalizationGQL
      .fetch({})
      .pipe(pluck('data', 'getMinePersonalization'), first())
      .subscribe((personalization) => {
        console.log(personalization);
        store.dispatch(
          SetCustomization({ customization: JSON.parse(personalization) }),
        );
      });
    actions$.pipe(ofType(SaveCustomizations)).subscribe(({ customization }) => {
      combineLatest(
        customization.map(({ name, value }) =>
          savePersonalizationGQL.mutate({ variables: { name, value } }),
        ),
      )
        .pipe(first())
        .subscribe();
    });
    actions$
      .pipe(
        // tap((x) => console.log(x)),
        ofType(FixMissingUserAvatar),
        // tap((x) => console.log(x))
      )
      .subscribe(() => {
        this.dialog.openRight(AvatarQuickFixComponent);
      });
    actions$
      .pipe(
        // tap((x) => console.log(x)),
        ofType(PickFilesFromContext),
        // tap((x) => console.log(x))
      )
      .subscribe(({ context, contextId, limit, taskId, skip, statusList }) => {
        const ref = this.dialog.openFull(ImagesInContextDrawerComponent, {
          closable: false,
          isBare: true,
        });
        ref.componentInstance.hasSelection = false;
        ref.componentInstance.hasPhotoOptions = false;
        ref.componentInstance.skip = skip ?? [];
        ref.componentInstance.pickerLimit = limit;
        console.log(
          `


        STATUS LIST

        `,
          statusList,
        );
        ref.componentInstance.statusDetails = statusList;
        switch (context) {
          case ImagesContainer.PrivateSession:
            ordersSearchService
              .getOrdersForStats(
                organizationService.lastOrganizationId,
                context as any as OrderContext,
                contextId,
              )
              .pipe(first())
              .subscribe((res) => {
                const ordered: Record<string, PhotoStatusOnTheList> = statusList
                  ? statusList
                  : {};

                res.forEach((order) => {
                  order.digital?.fileList.files.forEach((file) => {
                    ordered[file.photoId] = {
                      ordered: true,
                      favorites: statusList
                        ? statusList[file.photoId]?.favorites
                        : false,
                    };
                  });
                });
                ref.componentInstance.statusDetails = ordered;
              });
            break;
        }

        ref
          .afterOpened()
          .pipe(first())
          .subscribe(() => {
            ref.componentInstance.context = context;
            ref.componentInstance.contextId = contextId;
          });

        ref.componentInstance.isPicker = true;

        ref.componentInstance.selected
          .pipe(takeUntil(ref.afterClosed()))
          .subscribe((pickedImages) => {
            ref.close();
            if (pickedImages instanceof Array && pickedImages.length > 0) {
              store.dispatch(
                PickFilesFromContextResult({ taskId, results: pickedImages }),
              );
            }
          });
        ref
          .afterClosed()
          .pipe(takeUntil(ref.componentInstance.selected), first())
          .subscribe(() => {
            console.log('canceled');
            store.dispatch(PickFilesFromContextResult({ taskId, results: [] }));
          });
      });
    getMineMenuSortOrderGQL
      .watch({})
      .valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((result) => result.data['getMineMenuSortOrder']['order']),
        startWith(
          localStorage.getItem('menu-order')
            ? JSON.parse(localStorage.getItem('menu-order'))
            : [],
        ),
        delay(1),
        filter(({ length }) => length > 0),
        tap((visibility) =>
          localStorage.setItem('menu-order', JSON.stringify(visibility)),
        ),
      )
      .subscribe((v) => this.currentSortOrder$.next(v));
    getMineMenuVisibilityGQL
      .watch({})
      .valueChanges.pipe(
        throwOnQueryError,
        filter(hasCompleteQueryData),
        map((result) => result.data['getMineMenuVisibility']['visibility']),
        startWith(
          localStorage.getItem('menu-visibility')
            ? JSON.parse(localStorage.getItem('menu-visibility'))
            : [],
        ),
        delay(1),
        tap(() => {
          this.navigationConfigNotLoaded = false;
          this.changeDetectorRef.detectChanges();
        }),
        filter(({ length }) => length > 0),
        tap((visibility) =>
          localStorage.setItem('menu-visibility', JSON.stringify(visibility)),
        ),
      )
      .subscribe((visibility) => {
        this.mainMenu = this.mainMenu.map(({ id, ...rest }) => ({
          id,
          ...rest,
          isVisible: visibility.includes(id),
        }));

        this.changeDetectorRef.detectChanges();
      });
    let visualGuideInjected = null;
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter(
          ({ key, ctrlKey, shiftKey }) => key === 'L' && ctrlKey && shiftKey,
        ),
      )
      .subscribe(async (e) => {
        if (!visualGuideInjected) {
          const { ZalamoVisualGuideAdminModule } =
            await import('ZalamoLibrary/src/lib/ui/zalamo-visual-guide-admin/zalamo-visual-guide-admin.module');

          const injector = createInjector(
            ZalamoVisualGuideAdminModule,
            this.injector,
          );
          const carouselModule = injector.get(ZalamoVisualGuideAdminModule);
          visualGuideInjected = carouselModule;
        }
        visualGuideInjected.showEditor();
      });
  }

  @HostListener('document:touchmove', ['$event'])
  cos(e) {
    if (e.touches[0].clientY !== e.touches[0].pageY) {
      e.preventDefault();
    }
  }

  sortUpdated(newOrder) {
    console.log(newOrder);
    this.updateMineMenuSortOrderGQL
      .mutate({
        ...{
          optimisticResponse: {
            updateMineMenuSortOrder: withApolloTypename('MainMenuSortOrder', {
              order: newOrder,
              mainMenuSortOrderId: 'me',
            }),
          },
        },
        variables: { newSortOrder: newOrder },
      })
      .pipe(first())
      .subscribe();
  }

  visibilityUpdated(newVisibility: { id: string; visibility: boolean }) {
    this.mainMenu.find(({ id }) => id === newVisibility.id).isVisible =
      newVisibility.visibility;
    this.mainMenu = [...this.mainMenu];
    this.updateMineMenuVisibilityGQL
      .mutate({
        variables: {
          visibility: this.mainMenu
            .filter(({ isVisible }) => isVisible)
            .map(({ id }) => id),
        },
      })
      .subscribe();
  }

  ngOnInit() {}

  hide() {
    // this.isSupportVisible.next(false);
    this.wasHidden = true;
  }

  close() {
    this.store.dispatch(ToggleSupportChatIcon({ force: false }));
    this.store.dispatch(ToggleSupportChat({ force: false }));
    this.wasHidden = false;
  }

  showSupport(show) {
    console.log('show');
    if (show === 'chat') {
      // if (this.isChatOpen.value) {
      //   this.wasHidden = !this.wasHidden;
      // } else {
      //   this.isChatOpen.next(true);
      // }

      this.isFaqOpen.next(false);
    }
    if (show === 'faq') {
      this.isFaqOpen.next(true);
      // this.isChatOpen.next(false);
      this.wasHidden = false;
    }
  }

  logout() {
    this.zalamoAuthService
      .logoutCurrentUser()
      .pipe(
        first(),
        tap(() => {
          this.jwtService.logout();
        }),
      )
      .subscribe();
  }
}
